module.exports = "- Adjust to proper size to highlight importance but not occupying too much space.\n- Be simple and concise.\n"